import { DriversLicenseNumberConfig } from './drivers-licence-number-config';
import { DriversLicenseCardNumberConfig } from './drivers-license-card-number-config';

export const defaultFieldConfig = {
  name: {
    maskPattern: {
      pattern: {
        A: { pattern: new RegExp('^[a-zA-Z]$') },
        B: { pattern: new RegExp('^[a-zA-Z \'-]$') },
      },
      mask: 'AB*',
    },
    config: [
      {
        slug: 'no-whitespace',
        configContext: {},
      },
      {
        slug: 'pattern',
        configContext: { pattern: '^[a-zA-Z][a-zA-Z \'-]*$' },
      },
      {
        slug: 'len',
        configContext: { min: 2 },
      },
    ],
  },
  alphanumericName: {
    maskPattern: {
      pattern: {
        A: { pattern: new RegExp('^[a-zA-Z0-9]$') },
        B: { pattern: new RegExp('^[a-zA-Z0-9 \'-]$') },
      },
      mask: 'AB*',
    },
    config: [
      {
        slug: 'no-whitespace',
        configContext: {},
      },
      {
        slug: 'pattern',
        configContext: { pattern: '^[a-zA-Z0-9][a-zA-Z0-9 \'-]*$' },
      },
      {
        slug: 'len',
        configContext: { min: 2 },
      },
    ],
  },
  fullName: {
    maskPattern: {
      pattern: {
        A: { pattern: new RegExp('^[a-zA-Z]$') },
        B: { pattern: new RegExp('^[a-zA-Z \'-]$') },
      },
      mask: 'AB*',
    },
    config: [
      {
        slug: 'no-whitespace',
        configContext: { },
      },
      {
        slug: 'pattern',
        configContext: { pattern: '^[a-zA-Z][a-zA-Z \'-]{1,} [a-zA-Z][a-zA-Z \'-]{1,}$' },
      },
    ],
  },
  postCode: {
    maskPattern: {
      pattern: {
        A: { pattern: new RegExp('^\\d$') },
      },
      mask: 'AAAA',
    },
    config: [
      {
        slug: 'required',
        configContext: {},
      },
      {
        slug: 'pattern',
        configContext: { pattern: '^\\d{4}$' },
      },
    ],
  },
  driversLicenceNumber: DriversLicenseNumberConfig,
  driversLicenceCardNumber: DriversLicenseCardNumberConfig,
  email: {
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^\\S+[@]\\S+[.]\\S+$' },
      },
    ],
  }
};
